const reviewSwiperContainer = document.querySelector('.reviews-section .swiper-container');
if (reviewSwiperContainer) {
  new Swiper(reviewSwiperContainer, {
    slidesPerView: 5,
    spaceBetween: 8,
    centeredSlides: true,
    initialSlide: 4,
    grabCursor: true,
    loop: true,
    loopAdditionalSlides: 4,
    loopedSlides: 10,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    breakpoints: {
      0: {
        slidesPerView: "auto",
        centeredSlides: true,
      },
      480: {
        slidesPerView: "auto",
        centeredSlides: true,
      },
      768: {
        slidesPerView: 3,
        centeredSlides: false
      },
      1024: {
        slidesPerView: 5,
        centeredSlides: true
      }
    }
  });
}
